import axios from 'axios';
import moment from 'moment';
import { useState } from 'react';
import { CreateTicket } from 'src/components/Tickets/models/Tickets.interface';
import { analyticsEventSend } from 'src/utils/analytics/analyticsEventSend';
import { useAlertMessage } from 'src/hooks/useAlertMessage';
import { DEFAULT_DATE_FORMAT } from 'src/tabs/constants/Common.constants';

export const useCreateTicket = () => {
  const {
    hideAlert,
    requestStatusAppearance,
    requestStatusMessage,
    showAlert,
  } = useAlertMessage();
  const [ticket, setTicket] = useState();
  const [isLoadingCreateTicket, setIsLoadingCreateTicket] = useState<boolean>();

  const createTicket = async ({
    new_tickettype,
    new_priority,
    _new_category_value,
    new_description,
    new_requestedduedate,
  }: CreateTicket) => {
    if (isLoadingCreateTicket) return;

    try {
      setIsLoadingCreateTicket(true);
      const { data } = await axios.post('api/tickets', {
        new_tickettype,
        new_priority,
        _new_category_value,
        new_description,
        new_requestedduedate:
          new_requestedduedate && parseDateTimeToDate(new_requestedduedate),
      });

      data && setTicket(data);
      analyticsEventSend('New ticket request posted');
      showAlert('Ticket submitted successfully.', 'success');
    } catch {
      setTicket(undefined);
      showAlert('Failed to create ticket', 'error');
    } finally {
      setIsLoadingCreateTicket(false);
    }
  };

  return {
    ticket,
    isLoadingCreateTicket,
    requestStatusAppearance,
    requestStatusMessage,
    hideAlert,
    createTicket,
  };
};

const parseDateTimeToDate = (date: Date) => {
  return moment(date).format(DEFAULT_DATE_FORMAT);
};
